export default {
  SET_USER: (state, user) => {
    state.user = {
      ...user,
      admin_type: "s_admin",
    };
  },
  SET_FORGOT_PASSWORD_EMAIL: (state, email) => {
    state.forgotPasswordEmail = email;
  },
};
